import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { appStoreEffects } from '../../data/store/AppStore'
import { useSideEffect } from '../../data/store/Effects/side-effects'
import TopLevelRoutes from './Routes'
import './App.css'
import Header from '../components/Header'
import { reportErrorToServer } from '../../error-logger'

export default function App(): JSX.Element | null {
  const [isLoaded, setLoaded] = useState(false)

  const dispatchEffect = useSideEffect()
  useEffect(() => {
    dispatchEffect(appStoreEffects.initialize())
      .then(() => {
        setLoaded(true)
      })
      .catch(reportErrorToServer)
  }, [])

  if (!isLoaded) return null

  return (
    <Router>
      <>
        <Header />
        <TopLevelRoutes />
      </>
    </Router>
  )
}
